import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=6bfa1b8a&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bfa1b8a')) {
      api.createRecord('6bfa1b8a', component.options)
    } else {
      api.reload('6bfa1b8a', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=6bfa1b8a&", function () {
      api.rerender('6bfa1b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZcGYy39i5V5m/JS/comp/openstreetmap.vue"
export default component.exports